<template>
  <v-data-table
    :headers="headers"
    :items="equipments"
    class="elevation-1"
    item-key="descrizione"
    value="equipments"
    :sort-by="['descrizione']"
    :sort-desc="false"
      :loading="loading"
    :show-select="Boolean(this.showSelect)"
      :search="search"  
    v-model="selectedItems"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Attrezzatura</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
           <v-text-field
            v-model="search"
            class="mx-5"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field> 
        <v-dialog v-model="dialog" max-width="800px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Nuovo
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-card-text>
                    <v-container>
                      <v-text-field
                        label="Descrizione"
                        type="text"
                        v-model="editedEquipment.descrizione"
                      ></v-text-field>
                    </v-container>
                  </v-card-text>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="600px">
          <v-card>
            <v-card-title class="headline"
              >Are you sure you want to delete this equipment?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
   
    
     <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </v-data-table>
</template>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
export default {
  props: ["showSelect","selectedEquipment"],
  data: () => ({
    dialog: false,
    dialogDelete: false,
    error: "",
    loading:false,
    search: "",
    headers: [
      { text: "Descrizione", value: "descrizione" },

      { text: "Actions", value: "actions", sortable: false },
    ],
    equipments: [],
    selectedItemsArr: [],
    editedIndex: -1,
    editedEquipment: {
      descrizione: "",
    },
    defaultItem: {
      descrizione: "",
    },
  }),

  computed: {
    selectedItems: {
      get() {
        return this.selectedItemsArr;
      },
      set(value) {
        this.selectedItemsArr = value;
        console.debug("raising event itemSelected...");
        this.$emit("item-selected", this.selectedItemsArr);
      },
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Equipment" : "Edit Equipment";
    },
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },

  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    selectedEquipment(value){
      console.debug("equipment changed");
      this.selectedItemsArr=value;
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    // SelectedItems: function (val){
    //   this.selectedItems = val;
    // }
  },

  created() {
    this.initialize();

    // if(this.SelectedItems != undefined)
    // this.selectedItems = this.SelectedItems;
  },

  methods: {
    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.loadEquipments();
    },

    loadEquipments() {
      console.log("loading equipments...");
      this.loading=true;
      EasyPlanClient.Resources.GetAllEquipments(this.$route.params.companyAlias)
        .then((res) => {
          this.equipments = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        }).finally(()=>{
          this.loading=false;
        });
    },

    insertEquipment(equipment){
      EasyPlanClient.Resources.Insert(
        this.$route.params.companyAlias,
        equipment.descrizione,
        2
      ).then((res) => {
          console.debug("risposta add equipment:");
          console.debug(res);
          this.equipments.push(res.data.data);
          this.loadEquipments();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

      editEquipment(equipment) {
      EasyPlanClient.Resources.Update(this.$route.params.companyAlias, equipment)
        .then((res) => {
          console.debug("risposta edit equipment:");
          console.debug(res);
          this.loadEquipments();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },


    editItem(item) {
      this.editedIndex = this.equipments.indexOf(item);
      this.editedEquipment = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.equipments.indexOf(item);
      this.editedEquipment = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      
      EasyPlanClient.Resources.Delete(this.$route.params.companyAlias,
         this.editedEquipment.idRisorsa).then((res)=>{ 
            this.equipments.splice(this.editedIndex, 1);
            this.closeDelete();
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedEquipment = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedEquipment = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        this.editEquipment(this.editedEquipment);
        Object.assign(this.equipments[this.editedIndex], this.editedEquipment);
      } else {
        this.insertEquipment(this.editedEquipment);
      }
      this.close();
    },
  },
};
</script>